import type { Stage } from '@shared/model';
import { STAGE_COLOR, STAGE_LABEL } from '@shared/model';

export function StagePill({ stage, small }: { stage: Stage; small?: boolean }): JSX.Element {
  return (
    <span className={`stage-pill ${small ? 'stage-pill--small' : ''}`} style={{ borderColor: STAGE_COLOR[stage], color: stage === 'target' ? 'var(--text-muted)' : STAGE_COLOR[stage] }}>
      <i style={{ background: STAGE_COLOR[stage] }} />
      {STAGE_LABEL[stage]}
    </span>
  );
}
